<div class="md-block" *ngIf="text">
	<div class="md-block-icon" [style.background-color]="hexColor">
		{{ letter }}
	</div>
	{{ text }}
	<fitech-workspace-icon-tooltip *ngIf="isExclamation" [icon]="'warning'" [position]="'above'" [message]="exclamationMessage"></fitech-workspace-icon-tooltip>
</div>
